require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./button"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./button"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./button")) : factory(root["./utils"], root["./button"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__15__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[46],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(428);


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _PushButton = _interopRequireDefault(__webpack_require__(429));

exports["default"] = _PushButton["default"];
exports.PushButton = _PushButton["default"];

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _utils = __webpack_require__(4);

var _PushButton = _interopRequireDefault(__webpack_require__(430));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var pushButtonClassName = _PushButton["default"].pushButtonClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var PushButton = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(PushButton, _Component);

  function PushButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (button) {
      _this._button = button;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClick", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          onClick = _this$props.onClick;
      onChange && onChange(!checked);
      onClick && onClick(e);
    });
    return _this;
  }

  var _proto = PushButton.prototype;

  _proto.focus = function focus() {
    this._button && this._button.focus();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        checked = _this$props2.checked,
        disabled = _this$props2.disabled,
        className = _this$props2.className,
        style = _this$props2.style,
        variant = _this$props2.variant,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["checked", "disabled", "className", "style", "variant"]);
    var classNames = (0, _utils.classnames)(pushButtonClassName, {
      checked: checked
    });
    var buttonPassthroughProps = getInheritedProps(others, _button["default"]);
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: classNames + " " + className,
      style: style
    }, /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
      "data-tid": "ba-common-push-button__button"
    }, sanitize(others, PushButton), buttonPassthroughProps, {
      role: "button",
      ref: this._ref,
      "aria-pressed": checked,
      variant: variant != null ? variant : 'barOff',
      className: "push-button",
      onClick: this._onClick,
      disabled: disabled
    })));
  };

  return PushButton;
}(_react.Component);

exports["default"] = PushButton;
(0, _defineProperty2["default"])(PushButton, "propTypes", (0, _extends2["default"])({}, _button["default"].propTypes, {
  checked: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
}));
(0, _defineProperty2["default"])(PushButton, "defaultProps", {
  checked: false,
  className: '',
  style: {}
});

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(431);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-pushbutton button:focus{border:none;box-shadow:none}.ba-pushbutton.is-checked button.push-button{border:2px solid !important;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);background-color:#e0e0e0;background-color:hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1)}\n", ""]);

// exports
exports.locals = {
	"pushButtonClassName": "\"ba-pushbutton\""
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[427,0]]]);
});